<template>
  <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="180px"
  >
<!--    <section slot="driverBasealary"  slot-scope="prop" style="display: flex">-->

<!--      <el-input style="width: 240px" v-model="prop.form.driverBasealary"  placeholder="请输入"></el-input>-->
<!--      <span style="margin-right: 114px">&nbsp;</span>-->
<!--    </section>-->
    <span slot="carPrepayMoney">
      <span class="primary cur detailBtn" @click="toDetail">明细</span>
      <span v-show="getDetailLoading">=</span>
      <div class="detailBox" v-show="getDetailLoading" >

        <span></span>
        <i class="el-icon-plus primary"></i>
        <span class="primary cur" style="margin-left: 5px" @click="addExpenseType()">添加费用类型</span>
        <!-- 固定的四行数据-->
        <div v-for="(item,index) in buttonData" :key="item.id" class="itemRow">
            <el-popover
                placement="top-start"
                title=""
                width="200"
                trigger="hover"
                :content="item.moneyTypeName"

            >
              <span  class="labelText" slot="reference"  v-if="item.moneyTypeName.length>10">
                <span>{{item.moneyTypeName}}</span>
              </span>

            </el-popover>
           <span class="labelText" v-if="item.moneyTypeName.length<=10">{{item.moneyTypeName}}</span>
           <span style="margin-right: 15px">{{':'}}</span>
           <el-input
               style="width: 240px"
               class="inputBox small-input-box"
               v-model="item.moneyTypeValue"
               placeholder="输入金额"
               @blur=setCarPrepayMoney
               onkeyup="value=value.replace(/[^\d\.]/g,'').replace(/^0(\d+)$/,'$1')"
           >
           </el-input>
           <span class="warning cur delBtn"
                 @click="delExpenseType('buttonData',index)"
           >删除</span>

        </div>

        <div v-for="(item,index) in expenseTypeList" :key="item.id"  class="itemRow" v-show="expenseTypeList.length>0">
<!--          <el-input-->
<!--              class="inputBox label-input-box"-->
<!--              v-model="item.moneyTypeName"-->
<!--              placeholder="输入项目名称"-->
<!--          >-->
<!--          </el-input>-->
           <el-select
               class="inputAppendSelect"
               v-model="item.moneyTypeName"
               :clear="true"
               placeholder="请选择"
               style="margin-right: 15px"
           >
                <el-option
                    v-for="item in expenseTypeOptions"
                    :key="item.codeValue"
                    :label="item.codeName"
                    :value="item.codeName" />
              </el-select>
           <el-input
               :disabled="item.moneyTypeName.length <= 0"
               style="width: 240px"
               class="inputBox value-input-box"
               v-model="item.moneyTypeValue"
               placeholder="输入金额"
               @blur=setCarPrepayMoney
               onkeyup="value=value.replace(/[^\d\.]/g,'').replace(/^0(\d+)$/,'$1')"
           >

          </el-input>
         <span class="warning cur delBtn"
               @click="delExpenseType('expenseTypeList',index)"
         >删除</span>
        </div>

      </div>

      </span>
  </qx-custom-form>
</template>

<script>
import {getPaymentDetailsSysData} from 'api/getPay';
import {dealNumber, isExist} from '@qx/utils';
export default {
  props: {
    orderData: {
      type: Array,
      default: () => ([]),
    },
  },
  data () {
    return {
      isHide: false,
      getDetailLoading: true, // 获取详情loading
      coDriverBasealaryShow: false, // 判断副驾基本工资是否显示，显示副驾基本工资表单时要一下样式处理
      expenseTypeOptions: [],
      expenseTypeList: [],
      buttonData: [],
      baseForm: {
        form: [
          {
            label: '单/双驾',
            value: 'drivingType',
            type: 'input',
            hide: true,
          },
          {
            label: '应付运费',
            value: 'fullFreight',
            type: 'input',
            hide: true,
            onInput: (fullFreight) => {
              this.$refs.baseForm.setVal('fullFreight', dealNumber(fullFreight, false));
            },
          },
          {
            label: '项目部应付运费',
            value: 'projectSettlementPrice',
            type: 'input',
            hide: true,
            disabled: true,
          },
          {
            label: '本趟运费',
            value: 'freightOfOrder',
            type: 'input',
            hide: true,
            disabled: true,
            onBlur: () => this.setDriverBasealary(),
            onInput: (freightOfOrder) => {
              this.$refs.baseForm.setVal('freightOfOrder', dealNumber(freightOfOrder, false));
            },
          },
          {
            label: '实发比例',
            value: 'actualProportion',
            type: 'input',
            hide: true,
            default: '10',
            unit: '%',
            onBlur: () => {
              this.setDriverBasealary();
              this.setFreightOfOrder();
            },
            onInput: (actualProportion) => {
              this.$refs.baseForm.setVal('actualProportion', dealNumber(actualProportion, false));
            },
          },
          {
            label: '主驾基本服务费',
            value: 'driverBasealary',
            type: 'input',
            default: '0',
            hide: true,
            onInput: (driverBasealary) => {
              this.$refs.baseForm.setVal('driverBasealary', dealNumber(driverBasealary, true));
            },
            onBlur: () => this.setFreightOfOrder(),
          },
          {
            label: '副驾基本服务费',
            value: 'coDriverBasealary',
            type: 'input',
            default: '0',
            hide: true,
            onInput: (coDriverBasealary) => {
              this.$refs.baseForm.setVal('coDriverBasealary', dealNumber(coDriverBasealary, false));
            },
          },
          {
            label: '收款角色',
            value: 'payee',
            type: 'radio',
            default: 0,
            options: [
              { label: '主驾', value: 0 },
              { label: '副驾', value: 1 },
            ],
            hide: true,
          },
          {
            label: '司机是否可见服务费',
            value: 'showWagesFlg',
            type: 'radio',
            default: 0,
            options: [
              { label: '是', value: 1 },
              { label: '否', value: 0 },
            ],
            hide: true,
          },
          {
            label: '税点及操作费用',
            value: 'taxPoint',
            type: 'input',
            default: '7',
            unit: '%',
            hide: true,
          },
          {
            label: '其他费用',
            value: 'otherFee',
            type: 'input',
            hide: true,
          },
          {
            label: '油/气耗上报角色',
            value: 'reportingRole',
            type: 'radio',
            default: 0,
            options: [
              { label: '主驾', value: 0 },
              { label: '副驾', value: 1 },
            ],
            hide: true,
          },
          {
            label: '预支/借支款金额',
            value: 'carPrepayMoney',
            type: 'input',
            placeholder: ' ',
            allcustom: true,
            readonly: true,
            hide: true,
          },
        ],
        rules: {
          fullFreight: [
            { required: true, message: '请输入应付运费', trigger: 'blur' },
          ],
          freightOfOrder: [
            { required: true, message: '请输入本趟运费', trigger: ['change', 'blur'] },
          ],
          drivingType: [
            { required: true, message: '请输入单/双驾信息', trigger: ['change', 'blur'] },
          ],
          actualProportion: [
            { required: true, message: '请输入实发比例', trigger: 'blur' },
            {
              validator: this.checkActualProportion, trigger: 'blur',
            },
          ],
          driverBasealary: [
            { required: true, message: '请输入主驾基本服务费', trigger: ['change', 'blur'] },
          ],
          coDriverBasealary: [
            { required: true, message: '请输入副驾基本服务费', trigger: 'blur' },
          ],
          carPrepayMoney: [
            { required: false, message: '请填写至少一项费用类型', trigger: 'blur' },
            // {
            //   validator: this.checkCarPrepayMoney, trigger: 'change',
            // },
          ],
        },
      },
    };
  },
  methods: {
    setLineData (data) {
      this.$refs.baseForm.setVal(
        'fullFreight',
        isExist(data.fullFreight) ? (data.fullFreight / 100).toFixed(2) : this.$refs.baseForm.getVal('fullFreight')
      );
      this.$refs.baseForm.setVal(
        'projectSettlementPrice',
        isExist(data.projectSettlementPrice) ? (data.projectSettlementPrice / 100).toFixed(2) : this.$refs.baseForm.getVal('projectSettlementPrice')
      );
    },
    checkActualProportion (rule, value, call) {
      if (value > 100) {
        call('实发比例不能大于100%');
      } else {
        call();
      }
    },
    setList (paymentWayList = [], isCopilot, hasPersonalizedConfig = false) {
      const normalizedPaymentWayList = this.normalizePaymentWayList(paymentWayList);
      if (normalizedPaymentWayList.length === 0) {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          // 已配置订单模式但未勾选任何子字段时，应全部隐藏；只有完全没有个性化配置时才展示默认字段。
          value: hasPersonalizedConfig,
        });
      } else {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
        });
        this.paymentWayList = normalizedPaymentWayList;
        normalizedPaymentWayList.map((listItem) => {
          this.baseForm.form.map((formItem) => {
            if (listItem.value === formItem.value) {
              formItem.label = listItem.label;
              Object.keys(this.baseForm.rules).forEach((ruleItem, ruleIndex) => {
                if (listItem.value === ruleItem) {
                  this.baseForm.rules[ruleItem][0].message = '请输入' + listItem.label;
                }
              });
            }
          });
        });
        this.formChange(normalizedPaymentWayList, isCopilot);
      }
      this.isHide = this.baseForm.form.filter((item) => item.value === 'actualProportion')[0].hide;
      this.setDrivingType(isCopilot);
    },
    normalizePaymentWayList (paymentWayList = []) {
      return paymentWayList.map((item) => {
        const rawValue = item.value || item.fieldName || item.filedName || item.name || '';
        const matchedForm = this.baseForm.form.find((formItem) => `${formItem.value}`.toLowerCase() === `${rawValue}`.toLowerCase());
        return {
          ...item,
          value: matchedForm ? matchedForm.value : rawValue,
          label: item.fieldAlias || item.alias || item.label || item.fieldName || rawValue,
        };
      }).filter((item) => item.value);
    },
    setDrivingType (isCopilot) {
      this.$refs.baseForm.setVal('drivingType', isCopilot ? '双驾' : '单驾');
    },
    formChange (paymentWayList, isCopilot) { // 根据接口配置订单模式展示的表单
      let baseFormArr = [];
      let paymentWayArr = [];
      this.baseForm.form.map((item) => {
        baseFormArr.push(item.value);
      });
      paymentWayList.map((item) => {
        paymentWayArr.push(item.value);
      });
      const same = baseFormArr.filter((item) => paymentWayArr.includes(item)).concat(paymentWayArr.filter((item) => baseFormArr.includes(item)));
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: false,
        names: [...new Set(same)],
      });
      const diff = baseFormArr.filter((item) => !paymentWayArr.includes(item)).concat(paymentWayArr.filter((item) => !baseFormArr.includes(item)));
      let arr = ['coDriverBasealary', 'payee', 'reportingRole'];
      const defaultShowArr = diff.filter((item) => !arr.includes(item)).concat(arr.filter((item) => !diff.includes(item)));
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: true,
        names: ['coDriverBasealary', 'payee', 'reportingRole'],
      });
      if (isCopilot && defaultShowArr.length > 0) {
        this.setOrderFormItemShowAndHide(false, defaultShowArr);
      }
      if (diff.length > 0) {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
          names: [...diff],
        });
      }
    },
    toDetail () {
      this.getDetailLoading = !this.getDetailLoading;
    },
    addExpenseType (index) { // 添加费用类型
      this.expenseTypeList.push({
        moneyTypeName: '',
        moneyTypeValue: '',
      });
    },
    delExpenseType (tar, index) { // 删除费用类型
      if (tar === 'buttonData') {
        this.buttonData.splice(index, 1);
        this.setCarPrepayMoney();
      }
      if (tar === 'expenseTypeList') {
        this.expenseTypeList.splice(index, 1);
        this.setCarPrepayMoney();
      }
    },
    formatMoneyForForm (value, doubleValue, defaultValue = '0') {
      if (doubleValue !== null && doubleValue !== undefined && doubleValue !== '') {
        return Number(doubleValue).toFixed(2);
      }
      if (value !== null && value !== undefined && value !== '') {
        // 详情和页面缓存进入本组件前已经统一为元；只有 setLineData 的线路接口值是分。
        return Number(value).toFixed(2);
      }
      return defaultValue;
    },
    // 设置司机打款金额
    setCacheAndDetailData (options = {}) {
      this.$refs.baseForm.setVal(
        'fullFreight',
        this.formatMoneyForForm(
          options.fullFreight,
          options.fullFreightDouble,
          this.$refs.baseForm.getVal('fullFreight')
        )
      );
      this.$refs.baseForm.setVal(
        'projectSettlementPrice',
        this.formatMoneyForForm(
          options.projectSettlementPrice,
          options.projectSettlementPriceDouble,
          this.$refs.baseForm.getVal('projectSettlementPrice')
        )
      );
      this.$refs.baseForm.setVal(
        'driverBasealary',
        this.formatMoneyForForm(options.driverBasealary, options.driverBasealaryDouble)
      );
      this.$refs.baseForm.setVal(
        'coDriverBasealary',
        this.formatMoneyForForm(options.coDriverBasealary, options.coDriverBasealaryDouble)
      );
      this.$refs.baseForm.setVal(
        'carPrepayMoney',
        this.formatMoneyForForm(options.carPrepayMoney, options.carPrepayMoneyDouble)
      );
      this.$refs.baseForm.setVal('payee', options.payee || 0);
      this.$refs.baseForm.setVal('taxPoint', options.taxPoint && Number(options.taxPoint).toFixed(2) || '0');
      this.$refs.baseForm.setVal('otherFee', this.formatMoneyForForm(options.otherFee, options.otherFeeDouble));
      this.$refs.baseForm.setVal('showWagesFlg', options.showWagesFlg || 0);
      this.$refs.baseForm.setVal(
        'freightOfOrder',
        this.formatMoneyForForm(options.freightOfOrder, options.freightOfOrderDouble)
      );
      this.$refs.baseForm.setVal('actualProportion', options.actualProportion && options.actualProportion || '10');
      this.$refs.baseForm.setVal('reportingRole', options.reportingRole || 0);
      this.$refs.baseForm.setVal('drivingType', options.drivingType || '');
    },
    setDriverBasealary () { // "本趟运费""实发比例"联动“主驾基本工资”
      const freightOfOrder = this.$refs.baseForm.getVal('freightOfOrder');
      const actualProportion = this.$refs.baseForm.getVal('actualProportion');
      // 未配置“实发比例”，实发比例默认为100%，配置了默认为10%
      if (this.isHide) {
        this.$refs.baseForm.setVal('driverBasealary', (freightOfOrder * 100 / 100).toFixed(2));
      } else {
        if (actualProportion && freightOfOrder) {
          this.$refs.baseForm.setVal('driverBasealary', (freightOfOrder * actualProportion / 100).toFixed(2));
        }
      }
    },
    setFreightOfOrder () { // “主驾基本工资”联动"本趟运费""实发比例"
      const driverBasealary = this.$refs.baseForm.getVal('driverBasealary');
      const actualProportion = this.$refs.baseForm.getVal('actualProportion');
      if (this.isHide) {
        this.$refs.baseForm.setVal('freightOfOrder', (driverBasealary / 100 * 100).toFixed(2));
      } else {
        if (actualProportion) {
          this.$refs.baseForm.setVal('freightOfOrder', (driverBasealary / actualProportion * 100).toFixed(2));
        }
      }
    },
    setCarPrepayMoney (e) {
      let totalFee = 0;
      let buttonDataTotal = 0;
      let expenseTypeListTotal = 0;
      this.buttonData.map((item) => {
        if (item.moneyTypeName) {
          buttonDataTotal += Number(item.moneyTypeValue);
        } else {
          this.$message({
            type: 'error',
            message: '请输入项目名称',
          });
        }
      });
      this.expenseTypeList.map((item) => {
        expenseTypeListTotal += Number(item.moneyTypeValue);
      });

      totalFee = buttonDataTotal + expenseTypeListTotal;
      this.$refs.baseForm.setVal('carPrepayMoney', totalFee.toFixed(2));
    },
    // 选择副驾信息，设置表单副驾基本工资显示隐藏
    setOrderFormItemShowAndHide (flag, defaultShowArr) {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: flag,
        names: [...defaultShowArr],
      });
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // 这里处理的格式必须和详情接口返回的一样
        if (formData.fullFreight === null || formData.fullFreight === undefined || formData.fullFreight === '') {
          formData.fullFreight = 0;
        }
        formData.actualProportion = this.isHide ? 100 : formData.actualProportion;
        formData = {
          ...formData,
          carPrepayMoneyDetail: JSON.stringify([...this.buttonData, ...this.expenseTypeList.filter((type) => type.moneyTypeName.length > 0)]),
        };
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      const formData = await this.handleSubData();
      return formData;
    },
  },

  async created () {
    const expenseTypeList = await getPaymentDetailsSysData({ // 费用类型
      codeType: 'ORDER_COST_TYPE',
    });
    this.expenseTypeOptions = [...expenseTypeList[0]];
    if (!this.$route.query.id) {
      this.expenseTypeOptions.map((item) => {
        this.buttonData.push({
          moneyTypeName: item.codeName,
          moneyTypeValue: '',
        });
      });
    }
    let data = [];
    if (this.orderData && this.orderData .length > 0) {
      data = this.orderData.map((item) => ({
        moneyTypeName: item.moneyTypeName,
        moneyTypeValue: (item.moneyTypeValue / 100.0).toFixed(2),
      }));
    }
    this.buttonData = data.length > 0 ? data : this.buttonData;
  },
};
</script>
<style lang="scss" scoped>
.detailBtn {
  position: relative;
  left: -40px;
}

.detailBox {
  width:480px;
  text-align: right;
  border: 1px solid #DCDFE6;
  background: #FAFAFA;
  padding: 10px 30px 10px 0px;

  //margin-top:10px;
  //position: relative;
  //top: -33px;
  //right: -300px;


  .itemRow {
    margin-top: 10px;
  }

  .labelText {
    //margin-top:10px;
    //text-align: right;
    width: 150px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    //word-break: break-all;
    display: inline-block;
    position:relative;
    top:10px
  }

  .label-input-box {
    width: 120px;
    margin-right: 15px;
  }

  //.value-input-box {
  //  width: 200px;
  //}
  .delBtn {
    margin-left: 20px;
  }
}
</style>
